export default {
  welcomes:'Welcome to the backstage, please select other menu bars on the left',
  rules: {
    username: 'Account cannot be empty！',
    password: 'password can not be empty！',
    code: 'verification can not be empty！'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/login.js